import React from "react";
import CustomChip from "../../../../components/CustomChip";
import CustomButtonLink from "../../../../components/buttons/CustomButtonLink";
import { PlusIconsOptions } from "../../../../components/buttons/IconButtons";
import LayoutBoardApp from "../Functionality/LayoutBoardApp";
import Panel from "./Panel";
import PanelEmptyState from "./PanelEmptyState";

/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    Full Stack
 * @Email       kpozos@ibl.mx
 *
 * Canvas of the active layout: layout badge, "Add new panel" action and the grid of panels.
 */
const LayoutBoard = ({
    layout,
    getPanelFeed,
    onLoadMore,
    onLoadAreaEvents,
    now,
    onCreateLayout,
    onAddPanel,
    onConfigurePanel,
    onExpandPanel,
    onDeletePanel,
    onResizePanel,
    onResizePanelEnd,
    canCreate = false,
    canUpdate = false,
    canDelete = false
}) => {
    const {
        t,
        hasLayout,
        hasPanels,
        rows,
        gridClassName,
        layoutChipColors
    } = LayoutBoardApp({ layout });

    return (
        <div id='div_lb_board' className='event-monitoring-board h-100 background-shades-100 border-radius-16px'>
            {hasLayout &&
                <div className='d-flex justify-content-between align-items-center'>
                    <CustomChip
                        legend={layout.name}
                        background={layoutChipColors.background}
                        fontColor={layoutChipColors.fontColor}
                        borderColor={layoutChipColors.borderColor}
                    />
                    {canCreate &&
                        <CustomButtonLink
                            id='btn_lb_add_panel'
                            name='add_new_panel'
                            Icon={PlusIconsOptions}
                            iconProps='btn-icon-svg-12px icon-color-general-950'
                            splitName={false}
                            className='fs-10px ibl-font-w-500 font-color-general-950 gap-2'
                            onClick={onAddPanel}
                        />
                    }
                </div>
            }

            {!hasLayout &&
                <PanelEmptyState
                    legend='you_have_not_created_any_layouts_yet'
                    action={canCreate ? 'create_layout' : null}
                    onAction={onCreateLayout}
                    add
                />
            }

            {hasLayout && !hasPanels &&
                <PanelEmptyState
                    legend='you_have_not_added_any_panels_yet'
                    action={canCreate ? 'add_a_panel' : null}
                    onAction={onAddPanel}
                    add
                />
            }

            {hasLayout && hasPanels &&
                <div className={gridClassName}>
                    {layout.panels.map((panel) => (
                        <Panel
                            key={panel.id}
                            panel={panel}
                            columns={layout.columns}
                            rows={rows}
                            feed={getPanelFeed(panel)}
                            onLoadMore={onLoadMore}
                            onLoadAreaEvents={onLoadAreaEvents}
                            now={now}
                            t={t}
                            onConfigure={onConfigurePanel}
                            onExpand={onExpandPanel}
                            onDelete={onDeletePanel}
                            onResize={onResizePanel}
                            onResizeEnd={onResizePanelEnd}
                            canCreate={canCreate}
                            canUpdate={canUpdate}
                            canDelete={canDelete}
                        />
                    ))}
                </div>
            }
        </div>
    );
};

export default LayoutBoard;
